import { render, staticRenderFns } from "./AdminMessage.vue?vue&type=template&id=df682fd4&scoped=true&"
import script from "./AdminMessage.vue?vue&type=script&lang=js&"
export * from "./AdminMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df682fd4",
  null
  
)

export default component.exports